import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import {Document } from '../_models';

@Injectable({ providedIn: 'root' })
export class PdfService {

    constructor(
        private http: HttpClient,
        private router: Router) { }
    
    getMetada(){
        return this.http.get(`${environment.baseUrl}/pdf/metada`) || '';
    }

    
}